import { DocumentQuality } from "./classes/DocumentQuality";
import { rotate } from "./utils/utils";
 

export class DocumentQualityClassification {
    constructor() {
        return (async () => {
            this.config = await this.loadConfig();
            this.document_quality_classification = await new DocumentQuality();
            this.hasError = false;
            this.errorMessage = "";
            return this;
        })();
    }

    async loadConfig(){
        return fetch("./configs/configs.json").then((res)=>{
            return res.json();
        }).then((data)=>{
            return data;
        }).catch((err)=>{
            console.error(err)
        });

    }

    areModelsLoaded() {
        return this.document_quality_classification.checkModelisLoaded();
    }
    async processResult(
        image,
        rotation=0,
        letTestData=false,
    ) {
        let result = {}
        window.tf.engine().startScope();
        this.hasError=false;
        this.errorMessage="";
        let res = [];
        if (rotation != 0){
            image = rotate(image,rotation)
        }

        const [class_,score,hasError,errorMessage] = await this.document_quality_classification.predict(image);

        let isValidQuality = null;
        if (class_ == "good"){
            isValidQuality = true;
        }else{
            isValidQuality = false;
        }
        res["isValidQuality"]  = isValidQuality
        res["qualityScore"]  = score
        res["hasError"] = this.hasError;
        res["errorMessage"] = this.errorMessage;

        window.tf.engine().endScope();


        return res;
  }
}